export type Mode = 'instaflix' | 'reelsflix' | 'movieflix';
export const MODES: Mode[] = ['instaflix', 'reelsflix', 'movieflix'];
export const DEFAULT_MODE: Mode = 'instaflix';
